import type { PropsWithChildren } from 'react';

import type { IconName, IconVariant } from '~/chords';
import { Icon } from '~/components';

type ResultSectionProps = PropsWithChildren & {
  iconType: IconName;
  iconVariant?: IconVariant;
  title: string;
};

export function ResultSection({
  iconType,
  iconVariant = 'light',
  title,
  children,
}: ResultSectionProps) {
  return (
    <div
      className="flex flex-col border-b-px pb-md pt-sm border-emphasis-subtle last:border-0 last:pb-0"
      role="group"
    >
      <div className="mb-md flex flex-row items-center">
        <Icon
          className="pr-sm"
          type={iconType}
          aria-label={iconType}
          variant={iconVariant}
          size="sm"
          aria-hidden
        />
        <h4 className="text-body-sm font-semibold">{title}</h4>
      </div>
      {children}
    </div>
  );
}

ResultSection.displayName = 'ResultSection';
